module.exports = __webpack_public_path__ + "static/media/plus.fe50d7aa.svg";